<template>
  <span>
    <button
      type="button"
      class="btn btn-sm btn-link text-body-tertiary p-1"
      title="Transaction notifications"
      aria-label="Transaction notification settings"
      data-testid="transaction-notification-settings"
      @click="modalRef?.toggleModal()"
    >
      <font-awesome-icon icon="cog" />
    </button>

    <ModalComponent ref="modalRef" submitButtonText="Close" :noFooter="true">
      <template #title>Transaction notifications</template>
      <template #body>
        <div class="pb-3">
          <TransactionNotificationControls />
          <TransactionNotificationAutosendSwitch />
        </div>
      </template>
    </ModalComponent>
  </span>
</template>

<script setup lang="ts">
import ModalComponent from "@/components/common/ModalComponent.vue";
import { useTemplateRef } from "vue";
import TransactionNotificationControls from "../TransactionNotificationControls.vue";
import TransactionNotificationAutosendSwitch from "./TransactionNotificationAutosendSwitch.vue";

/**
 * Cog next to the transactions heading that opens the notification controls (manual release +
 * Friday auto-send switch) in a modal, keeping them off the list page itself. The modal body
 * mounts only while open, so the status polling runs only while an admin is looking at it.
 */

const modalRef =
  useTemplateRef<InstanceType<typeof ModalComponent>>("modalRef");
</script>
